import React from "react";
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js";
import queryString from "query-string";

import CardSection from "./CardSection";
// import axios from "axios";
import BounceLoader from "react-spinners/BounceLoader";
import "./CardSection.css";

class CheckoutForm extends React.Component {
  state = {
    loading: false,
  };

  handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    // console.log(event);
    // return;
    // let clientSecret = ;

    const { stripe, elements } = this.props;

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const card = elements.getElement(CardElement);
    const result = await stripe.createToken(card);

    if (result.error) {
      //   // Show error to your customer.
      console.log(result.error.message);
    } else {
      this.props.setPaymentLoading();
      this.setStateToLoading();

      let customerName =
        this.props.checkoutState.shippingAddress.fname +
        " " +
        this.props.checkoutState.shippingAddress.lname;

      stripe
        .confirmCardPayment(this.props.checkoutState.client_secret, {
          payment_method: {
            card: card,
            billing_details: {
              address: {
                city: this.props.checkoutState.shippingAddress.city,
                country: this.props.checkoutState.shippingAddress.country,
                line1: this.props.checkoutState.shippingAddress.addr,
              },
              name: customerName,
              email: this.props.checkoutState.shippingAddress.email,
              phone: this.props.checkoutState.shippingAddress.phone,
            },
          },
          receipt_email: this.props.checkoutState.shippingAddress.email,
          shipping: {
            address: {
              city: this.props.checkoutState.shippingAddress.city,
              country: this.props.checkoutState.shippingAddress.country,
              line1: this.props.checkoutState.shippingAddress.addr,
            },
            phone: this.props.checkoutState.shippingAddress.phone,
            name: customerName,
          },
        })
        .then((result) => {
          if (result.error) {
            // Show error to your customer (e.g., insufficient funds)
            console.log(result.error.message);
            this.props.completeCheckout("failed");
          } else {
            // The payment has been processed!
            if (result.paymentIntent.status === "succeeded") {
              // Show a success message to your customer
              // There's a risk of the customer closing the window before callback
              // execution. Set up a webhook or plugin to listen for the
              // payment_intent.succeeded event that handles any business critical
              // post-payment actions.
              // this.stripeTokenHandler(result.token, checkoutState);
              let checkoutState = this.props.checkoutState;
              console.log("Success?");
              this.props.completeCheckout("success");
              let params = queryString.parse(window.location.search);
              const paymentData = {
                checkoutId: params.checkoutID,
                checkoutState,
              };
              fetch(
                "https://zutp1rprgj.execute-api.eu-west-1.amazonaws.com/dev/checkout",
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(paymentData),
                }
              );
            }
          }
        });
    }
    //const result = await stripe.createToken(card);

    // if (result.error) {
    //   // Show error to your customer.
    //   console.log(result.error.message);
    // } else {
    //   // Send the token to your server.
    //   // This function does not exist yet; we will define it in the next step.
    //   let checkoutState = this.props.checkoutState;
    //   this.stripeTokenHandler(result.token, checkoutState);
    // }
  };

  stripeTokenHandler = async (token, checkoutState) => {
    //this.setStateToLoading();
    let params = queryString.parse(window.location.search);
    const paymentData = {
      checkoutId: params.checkoutID,
      //token: token.id,
      checkoutState,
    };
    // Use fetch to send the token ID and any other payment data to your server.
    // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch

    fetch(
      "https://zutp1rprgj.execute-api.eu-west-1.amazonaws.com/dev/checkout",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(paymentData),
      }
    )
      .then((response) => response.json())
      .then((responseRead) => {
        //console.log(body);
        console.log("checkoutResponse", responseRead);
        if (responseRead.status === "success") {
          this.props.completeCheckout("success");
        } else {
          this.props.completeCheckout("failed");
        }
      });
  };

  setStateToLoading = () => {
    this.setState({ loading: true });
  };

  render() {
    return (
      <div className="formContainer">
        <form onSubmit={this.handleSubmit}>
          <CardSection />

          {!this.state.loading ? (
            <button className="confirmButton" disabled={!this.props.stripe}>
              Confirm order
            </button>
          ) : (
            <div className="bounceLoader">
              <BounceLoader />
            </div>
          )}
        </form>
      </div>
    );
  }
}

export default function InjectedCheckoutForm(data) {
  console.log(data);
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <CheckoutForm
          stripe={stripe}
          elements={elements}
          setPaymentLoading={data.paymentLoading}
          checkoutState={data.checkoutState}
          completeCheckout={data.completeCheckout}
        />
      )}
    </ElementsConsumer>
  );
}
